// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gOnu","type":"styles_type__3WL0X","choices":"styles_choices__2fHoI"};